export interface IExaminationOrganization {
    guid: string;
    name: string;
    disabled: boolean;
    orderNumber: number;
    orderDirection: boolean;
    activeButtonUp: boolean;
    activeButtonDown: boolean;
}

export const InitIExaminationOrganization: IExaminationOrganization = {
    guid: "",
    name:"",
    disabled:false,
    orderDirection: false,
    orderNumber: 0,
    activeButtonUp:true,
    activeButtonDown: true,
}